import { Component, OnInit } from '@angular/core';
import { JWTUser, PaymentHistory } from 'Model';
import { PaymentService } from 'app/services/payment.service';
import { UtilserviceService } from 'app/services/utilservice.service';

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {
  history: Array<PaymentHistory> = [];
  subjectMaxArray = [];
  disableButton=false;
  style: any;
  constructor( public util: UtilserviceService,private payService:PaymentService) { }

  async ngOnInit(): Promise<void> {
    let user = JSON.parse(this.util.getCurrentUser()) as JWTUser;
    this.history = await this.payService.getPaymentHistory(user.email);
    this.style = this.util.getDomainEnviroment().style;
  }


  async checkpayment(history:PaymentHistory){
    try {
      this.disableButton = true;
      await this.payService.checkPaymentHistory(history.id);    
      window.location.reload();  
    } catch (error) {
      console.log(error);
    }finally{
      this.disableButton = false;
    }
  }

}
